import type { Observable, Subscription } from "rxjs";
import { setSentryUser } from "./sentry";

export interface AuthSession {
  user: { id: string } | null;
}

export function wireSentryUserToAuth(
  session$: Observable<AuthSession>,
): Subscription {
  return session$.subscribe((session) => {
    setSentryUser(session.user?.id ?? null);
  });
}
